import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Boxcard = () => {
  const [departmentDetails, setDepartmentDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.warn("No auth token found");
      navigate("/login");
    }

    
    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/get-departmentwise-data", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch tasks");

      const result = await response.json();
      setLoading(false);
      setDepartmentDetails(result || []);
    } catch (err) {
      console.error("Error fetching tasks:", err);
    }
    
  };
  if (loading) return <p>Loading...</p>;

  return (
    <div className="departmentwiseData p-4">
      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
        
        Department Wise Task Details
      </h2>
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {departmentDetails.map((d, index) => (
          <li
            key={d.id || index}
            className={`flex flex-col justify-between rounded-xl shadow-md p-4 bg-white hover:shadow-lg transition-shadow duration-300 ${
              index % 4 === 0
                ? "bg-red-50"
                : index % 4 === 1
                ? "bg-green-50"
                : index % 4 === 2
                ? "bg-teal-50"
                : "bg-pink-50"
            }`}
          >
            <div className="flex items-center justify-between">
              <h1 className="text-lg font-semibold text-gray-800 capitalize">
                {d.name}
              </h1>
              
            </div>

            <div className="flex justify-around text-center mt-3">
              <div>
                <div className="text-xs text-gray-500">Total Task</div>
                <div className="text-base font-bold text-gray-800">
                  {d.totalTask}
                </div>
              </div>
              <div>
                <div className="text-xs text-gray-500">Pending</div>
                <div className="text-base font-bold text-yellow-600">
                  {d.pendingTask}
                </div>
              </div>
              <div>
                <div className="text-xs text-gray-500">Completed</div>
                <div className="text-base font-bold text-green-600">
                  {d.completedTask}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Boxcard;
